import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * Minimum quantity allowed in cart
 */
const MIN_QUANTITY = 5;

/**
 * Cart Quantity Selector
 *
 * Minimum quantity = 5
 * Increment = 1
 *
 * 5 → 6 → 7 → 8 → 9 → 10 → ...
 */
export class CartQuantitySelectorComponent extends QuantitySelectorComponent {

  /**
   * Cart uses absolute maximum quantity
   */
  getEffectiveMax() {
    const { max } = this.getCurrentValues();

    return max;
  }

  /**
   * Cart buttons are always managed client-side
   */
  updateButtonStates() {
    const { minusButton, plusButton } = this.refs;

    const { min, value } = this.getCurrentValues();

    const effectiveMax = this.getEffectiveMax();

    // Minus disabled at 5
    minusButton.disabled = value <= Math.max(MIN_QUANTITY, min);

    // Plus disabled only at maximum
    plusButton.disabled =
      effectiveMax !== null &&
      value >= effectiveMax;
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define(
    'cart-quantity-selector-component',
    CartQuantitySelectorComponent
  );
}